import { createGlobalStyle } from 'styled-components'
import { textSize, textWeight, textColor } from 'lib/Text'

export const Reset = createGlobalStyle`
  /* Box sizing rules */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Remove default padding */
  ul,
  ol {
    padding: 0;
  }

  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  ol,
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  /* Set core body defaults */
  body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
    line-height: 1.5;
    font-family: Arial, sans-serif;
  }

  h1,h2,h3,h4,h5,h6 {
    font-weight: inherit;
    font-style: inherit;
    font-size: inherit;
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a class attribute */
  ul,
  ol {
    list-style: none;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    th,
    td {
      padding: 3px;
    }

    th {
      ${textSize('ps')}
      ${textWeight('semi')}
      ${textColor('neutral-80')}
      border-bottom: 1px solid var(--neutral-20);
    }

    tbody td {
      ${textSize('ps')}
      ${textWeight('regular')}
      ${textColor('neutral-80')}
      border-bottom: 1px solid var(--neutral-20);
    }
  }


  legend {
    float: left;
    margin: 0;
    padding: 0;
  }

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;      
    min-width: 0;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`
